<template>
    <div class="deck-card-partner__partner-badge" :class="{floating: floating}">
        <inline-svg src="/assets/img/icons/heart-circle.svg"></inline-svg>
        Inclusion Partner
    </div>
</template>

<script>
export default {
    name: "PartnerBadge",
    props: ['floating'],
}
</script>

<style scoped>

</style>
